import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieModule } from 'ngx-cookie';
import { DatePipe } from '@angular/common';
import { VideoEmbedComponent } from './video-embed/video-embed.component';
import { SharedComponentsModule } from './shared-components/shared-components.module';
import { MobileAppPaymentMethodsComponent } from './public/mobile-app-payment-methods/mobile-app-payment-methods.component';
import { NgxStripeModule } from 'ngx-stripe';
import { MobileAppPaymentCompletedComponent } from './public/mobile-app-payment-completed/mobile-app-payment-completed.component';
import { LottieModule } from 'ngx-lottie';

export const playerFactory = () => import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');

@NgModule({
  declarations: [AppComponent, VideoEmbedComponent, MobileAppPaymentMethodsComponent, MobileAppPaymentCompletedComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CookieModule.withOptions(),
    SharedComponentsModule,
    NgxStripeModule,
    LottieModule.forRoot({ player: playerFactory })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
